import { twMerge } from 'tailwind-merge';

interface RedDotProps {
  readonly className?: string;
}

function SidebarRedDot({ className }: RedDotProps) {
  return <div title="menu-with-red-dot" className={twMerge('ml-2 h-2 w-2 rounded-full bg-red-500', className)} />;
}

export { SidebarRedDot };
